// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NMXtl","top":"styles_top__SDQOh","left":"styles_left__gnXsh","description":"styles_description__2hDkY"};